if (document.querySelector('.template-connect-with-expert') && window.location.search) {
  const value = decodeURIComponent(window.location.search.replace('?s=', ''))
  Array.from(document.querySelectorAll('select')).forEach((element) => {
    Array.from(element.querySelectorAll('option')).forEach((option) => {
      if (option.getAttribute('value') === value) {
        option.setAttribute('selected', 'selected')
      }
    })
  })
}
